import Button from "components/buttons/Base";

function FormSubmitButton(props) {
  /** Standard button used to submit forms. */
  return <Button variant="primary" size="lg" type="submit" {...props}>{props.children}</Button>
}

export default FormSubmitButton;
